import React from 'react';
import * as search from 'searchtabular';

import PerPage from './PerPage';

import { Col, Row } from 'react-bootstrap';

import { Legende } from 'components'
import { translate } from 'react-i18next';

const PrimaryControls = ({
	perPage, columns, rows, column, query,
	onPerPage, onSearch, onColumnChange,
	pageProducts, t,
	...props
}) => (
		<div {...props}>

			<Row>
				<Col xs={3} md={2}>
					<div className="per-page-container">
						<PerPage value={perPage} onChange={onPerPage} />
					</div>
				</Col>

				<Col xs={4} md={3}>
					<div className="search-container">
						<span>{t("main.modules")} :</span> &nbsp;
		      			<search.Field
							column={column}
							query={query}
							columns={columns}
							rows={rows}
							onChange={onSearch} 
							onColumnChange={onColumnChange}
						/>
					</div>
				</Col>

				<Col xs={5} md={6}>
					<Legende />
				</Col>



			</Row>
		</div>
	);


export default PrimaryControls